export enum AttachCloudEntityType {
  Stack = "stack",
  Module = "module",
}
